import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BarChart2, Table2, List, Search, ExternalLink } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useSite } from '@/contexts/SiteContext';

const VIEWS = [
  { label: 'Funnel',   to: '/catalog/funnel',   icon: BarChart2 },
  { label: 'Pivot',    to: '/catalog/pivot',    icon: Table2 },
  { label: 'Monitor',  to: '/catalog/monitor',  icon: List },
  { label: 'Inspector',to: '/catalog/inspect',  icon: Search },
] as const;

interface LinkedViewsStripProps {
  sheetsUrl?: string | null;
}

export function LinkedViewsStrip({ sheetsUrl }: LinkedViewsStripProps) {
  const { pathname } = useLocation();
  const { selectedSite } = useSite();

  return (
    <div className="flex items-center gap-1 flex-wrap">
      {VIEWS.map(({ label, to, icon: Icon }) => {
        const active = pathname.startsWith(to);
        return (
          <Link
            key={to}
            to={to}
            className={cn(
              'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors',
              active
                ? 'bg-[#0E9D8A] text-white'
                : 'bg-muted text-muted-foreground hover:bg-muted/80 hover:text-foreground',
            )}
          >
            <Icon className="h-3.5 w-3.5" />
            {label}
          </Link>
        );
      })}
      {sheetsUrl && (
        <a
          href={sheetsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium bg-muted text-muted-foreground hover:bg-muted/80 hover:text-foreground transition-colors"
        >
          <ExternalLink className="h-3.5 w-3.5" />
          Open in Sheets ↗
        </a>
      )}
    </div>
  );
}
